import React, { useEffect } from 'react';
import './HardwareDesign.css';

const HardwareDesignPage = () => {
    useEffect(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => observer.observe(element));

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Architecture Design",
            description: "Designing robust hardware architectures for optimized performance in IoT and embedded systems."
        },
        {
            title: "Schematic Design",
            description: "Creating detailed schematics to ensure accurate component integration and functionality."
        },
        {
            title: "PCB Layout Design",
            description: "Developing precise PCB layouts for efficient signal routing and compact board design."
        },
        {
            title: "Design Analysis",
            description: "Performing comprehensive analysis to validate hardware performance and reliability."
        },
        {
            title: "SI, PI, EMI, Thermal Design",
            description: "Ensuring signal integrity, power integrity, EMI compliance, and effective thermal management."
        },
        {
            title: "Library Development Design",
            description: "Building reusable component libraries for streamlined hardware design processes."
        },
        {
            title: "RF Antenna Design",
            description: "Designing high-performance RF antennas for reliable wireless communication."
        },
        {
            title: "Testing Design",
            description: "Implementing rigorous testing protocols to ensure hardware quality and performance."
        },
        {
            title: "Component Engineering",
            description: "Designing and optimizing computing systems to enhance performance, reliability, and integration across hardware and software components."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                Hardware Design and Development
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our hardware design services deliver innovative, reliable, and efficient solutions tailored for IoT and embedded systems, ensuring seamless integration and performance.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Notes
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default HardwareDesignPage;